export const PROFESSIONAL_SERVICES_PROFILE_TYPE = 'Professional Services' as const;

export const PROFESSIONAL_SERVICES_MONTHLY_PRODUCT_CODE = 'PROSERV-MONTHLY-01' as const;
export const PROFESSIONAL_SERVICES_ANNUAL_PRODUCT_CODE = 'PROSERV-ANNUAL-01' as const;

// ── Early Adopters Lifetime Promo ──────────────────────────────────────────
// Existing subscribers keep legacy rates while active. Cancel/default → going rate.
// LEGACY (going) prices — DO NOT DELETE:
export const PROFESSIONAL_SERVICES_MONTHLY_PRICE_LEGACY = 975 as const;
export const PROFESSIONAL_SERVICES_ANNUAL_PRICE_LEGACY = 9500 as const;

// ── Current (going-rate) prices — effective now ──────────────────────────
export const PROFESSIONAL_SERVICES_MONTHLY_PRICE = 500 as const;
export const PROFESSIONAL_SERVICES_ANNUAL_PRICE = 5000 as const;

export const PROFESSIONAL_SERVICES_CATEGORY_OPTIONS = [
  'Accountants',
  'Advocates',
  'Architects',
  'Attorneys',
  'Business Consulting',
  'Conveyancers',
  'Debt Councillors',
  'Engineering Services',
  'Financial Services',
  'Funeral Services',
  'Graphic Designers',
  'HR Services',
  'Insurance Services',
  'Logistics Services',
  'Marketing Agencies',
  'Notaries',
  'Printing Services',
  'Real Estate Agents',
  'Recruitment Agencies',
  'Security Services',
  'Tax Consultants',
  'Training & Development',
  'Translation Services',
  'Travel Agencies',
  'Web Developers',
] as const;

export const isProfessionalServicesProductCode = (value: unknown): boolean => {
  const code = String(value || '').trim();
  return code === PROFESSIONAL_SERVICES_MONTHLY_PRODUCT_CODE || code === PROFESSIONAL_SERVICES_ANNUAL_PRODUCT_CODE;
};